/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */

// import { startIdentityLogin } from '../../redux/identity/identity-actions';
import Toast from '../common/Toast';

const LayoutEmpty = ({ children }: { children: React.ReactNode }) => (
 <>
  {children}
  <Toast />
 </>
);
export default LayoutEmpty;
